import * as tslib_1 from "tslib";
import * as React from 'react';
var initialState = {
    isSdkReady: false,
};
var Advisory = /** @class */ (function (_super) {
    tslib_1.__extends(Advisory, _super);
    function Advisory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.handleContact = function () {
            if (_this.state.isSdkReady) {
                window['ysf']('open');
                // location.href = ysf('url');
            }
            else {
                // 仅做参考
                alert('sdk尚未加载成功，请稍后再试');
            }
        };
        return _this;
    }
    Advisory.prototype.componentDidMount = function () {
        var useCustomIcon = this.props.useCustomIcon;
        (function (w, d, n, a, j) {
            w[n] = w[n] || function () {
                (w[n].a = w[n].a || []).push(arguments);
            };
            j = d.createElement('script');
            j.async = true;
            if (useCustomIcon) {
                j.src = 'https://qiyukf.com/script/61b5bec5f72b78b7a6bc598344c01c63.js?hidden=1';
            }
            else {
                j.src = 'https://qiyukf.com/script/61b5bec5f72b78b7a6bc598344c01c63.js';
            }
            d.body.appendChild(j);
        })(window, document, 'ysf');
        window['ysf']('config', {
            uid: JSON.parse(localStorage['$$/user']).userInfo.cUserId,
            name: JSON.parse(localStorage['$$/user']).userInfo.nickName,
            email: JSON.parse(localStorage['$$/user']).userInfo.email,
            mobile: JSON.parse(localStorage['$$/user']).userInfo.phone // 用户电话
        });
        this.setState({
            isSdkReady: true,
        });
    };
    Advisory.prototype.render = function () {
        var _a = this.props, useCustomIcon = _a.useCustomIcon, children = _a.children;
        if (useCustomIcon) {
            return (React.createElement("div", { onClick: this.handleContact, style: { cursor: 'pointer' } }, children));
        }
        else {
            return (React.createElement("div", { style: { display: 'none' } }, "Advisory was loaded!"));
        }
    };
    return Advisory;
}(React.Component));
export default Advisory;



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-qiyu-advisory/index.js
// module id = 6636
// module chunks = 0